import { convertDirection, convertDateForIos, convertToDayOfWeek, convertToTime } from '../helpers.js';

const renderWeatherSTEM = (data) => {
  data.forEach(wxStemSite => {
    const stemId = wxStemSite.main.id.split('@')[0];

    const minTemp = wxStemSite.supplemental.davis_current_observation.temp_day_low_f;
    const minTime = wxStemSite.supplemental.davis_current_observation.temp_day_low_time;
    const maxTemp = wxStemSite.supplemental.davis_current_observation.temp_day_high_f;
    const maxTime = wxStemSite.supplemental.davis_current_observation.temp_day_high_time;

    document.getElementById(`wxstem-${stemId}-temperature`).innerHTML = Math.round(wxStemSite.main.observation.temperature);
    document.getElementById(`wxstem-${stemId}-wind`).innerHTML = convertDirection(wxStemSite.main.observation.wind_direction).short + ' ' + Math.round(wxStemSite.main.observation.wind_speed) + ' mph &nbsp; '; 
    document.getElementById(`wxstem-${stemId}-gusts`).innerHTML = ' (gusts ' + Math.round(wxStemSite.main.observation.gust) + ')';

    // "Feels Like" temperature logic
    if (wxStemSite.main.observation.heat_index) {
      document.getElementById(`wxstem-${stemId}-feelslike`).innerHTML = `${ Math.round(wxStemSite.main.observation.heat_index) }&deg;`;
    } else if (wxStemSite.main.observation.wind_chill) {
      document.getElementById(`wxstem-${stemId}-feelslike`).innerHTML = `${ Math.round(wxStemSite.main.observation.wind_chill) }&deg;`;
    } else if (!wxStemSite.main.observation.heat_index && !wxStemSite.main.observation.wind_chill) {
      document.getElementById(`wxstem-${stemId}-feelslike`).innerHTML = `${ Math.round(wxStemSite.main.observation.temperature) }&deg;`;
    } else {
      document.getElementById(`wxstem-${stemId}-feelslike`).innerHTML = 'Not available';
    }

    document.getElementById(`wxstem-${stemId}-dewpoint`).innerHTML = Math.round(wxStemSite.main.observation.dewpoint) + '&deg;';
    document.getElementById(`wxstem-${stemId}-pressure`).innerHTML = parseFloat(wxStemSite.main.observation.pressure).toFixed(2) + '&#34; &nbsp';
    document.getElementById(`wxstem-${stemId}-tendency`).innerHTML = wxStemSite.main.observation.pressure_tendency.split(' ')[0];
    document.getElementById(`wxstem-${stemId}-precip24`).innerHTML = parseFloat(wxStemSite.main.observation.daily_rainfall).toFixed(2) + '&#34;';
    const iOSConversion = convertDateForIos(wxStemSite.main.observation.time);
    document.getElementById(`wxstem-${stemId}-updated`).innerHTML = convertToDayOfWeek(iOSConversion).short + '&nbsp;' + convertToTime(iOSConversion);


    document.getElementById(`wxstem-${stemId}-low`).innerHTML = Math.round(minTemp) + '&deg;&nbsp;';
    document.getElementById(`wxstem-${stemId}-lowtime`).innerHTML = 'at&nbsp;' + minTime;
    document.getElementById(`wxstem-${stemId}-high`).innerHTML = Math.round(maxTemp) + '&deg;&nbsp;';
    document.getElementById(`wxstem-${stemId}-hightime`).innerHTML = 'at&nbsp;' + maxTime;
  })
};

export { renderWeatherSTEM };